import {React, pluralize, Fragment} from '@api'
import {usePdfStore} from '@modules/pdf'
import {styled} from '@pdf'
import {Text} from '@react-pdf/renderer'
import {checked as checkedImage, unchecked} from '@resources'
import {ICatalogFieldConfig, ISectionConfig, ui, useCatalog} from '@stores'
import {VlpProductCardLineItem} from './';

const styles = () => {
  const pdf = usePdfStore()
  return {
    ViewRoot: styled.View`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `,
    CheckboxViewRoot: styled.View`
    display: inline-flex;
    overflow: hidden;
    flex-direction: row;
    align-items: center;
    margin-right: 2px;
    width: 38px;
  `,
    CheckboxImage: styled.Image`
    width: 12px;
    height: 12px;
    margin: 2px 2px 2px 0;
  `,
    CheckboxTextView: styled.View`
      font-size: ${pdf.labelFontSize}px;
      display:flex;
      flex-direction: row;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 100%;
      border:none;
      color: grey;
  `,
    CheckboxText: styled.Text`
      margin: auto 0px;
      text-overflow: ellipsis;
      overflow:hidden;
      max-lines: 1;
      flex-shrink:1;
      width: 38px;
      `,
    SectionField: styled.View`
      display:flex;
      overflow:hidden;
      margin-right: 5px;
      max-height: ${props => props.columns == 'standard' ? '20px' : props.columns == 'compact' ? '14px' : '20px'};
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      width: 35px;
    `,
   SectionFieldLabel: styled.View`
      font-size: ${pdf.labelFontSize}px;
      display:flex;
      flex-direction: row;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 100%;
      border:none;
      color: grey;
    `,
   SectionText: styled.Text`
      margin: auto 0;
      text-overflow: ellipsis;
      overflow:hidden;
      max-lines: 1;
      flex-shrink:1;
      `,
   SectionFieldValue: styled.View`
      font-size: ${pdf.cardFontSize}px;
      display:flex;
      flex-direction: row;
      align-content: center;
      align-items: center;
      flex-grow:1;
      overflow:hidden;
    `,

  }
}

const CheckboxPDF: React.FC<{ label: string, checked: boolean }> = ({label, checked}) => {
  const {CheckboxViewRoot, CheckboxImage, CheckboxText} = styles()
  return <CheckboxViewRoot>
    <CheckboxImage src={checked ? checkedImage : unchecked}/>
    <CheckboxText>{label}</CheckboxText>
  </CheckboxViewRoot>
}

export const RegionSelection: React.FC<{ data }> = function RegionSelection({data}) {
  const {cv: {groupedVisibleCardFields}, idFor, stores: {es}} = useCatalog(),
    {readField} = es,
    {ViewRoot, CheckboxTextView, CheckboxText} = styles(),
    id = idFor(data)
  return (
    <Fragment>
      {Object.keys(groupedVisibleCardFields).length > 0 &&
       Object.keys(groupedVisibleCardFields).map(group => <ViewRoot key={`${group}_${id}`} style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
         <CheckboxTextView>
           <CheckboxText>{group}</CheckboxText>
         </CheckboxTextView>
         {groupedVisibleCardFields[group].map(({field, def}) => <CheckboxPDF key={`${field}_${id}`} label={def?.displayName.singular} checked={Boolean(readField(data, field).val)}/>)
         }</ViewRoot>
       )}
    </Fragment>
  )
}
export const SectionalPDFFieldRenderer: React.FC<{
  field: ICatalogFieldConfig,
  sectionConfig?: ISectionConfig
  data?: any
  className?: string
}> = function SectionalPDFFieldRenderer({ field, sectionConfig, sectionConfig: { path, viewOptions }, data, className })  {

  const { ViewRoot, CheckboxTextView, CheckboxText, SectionField, SectionFieldLabel, SectionFieldValue, SectionText } = styles(), { config: { columns } } = usePdfStore(),
    catalog = useCatalog(),
    {strings, settings: {showCardLabels }} = catalog,
    {settings: {numberOfPDFVisibleViewOptions: visible}} = ui

    const array = _.get(data, path) ?? [],
      dict = _.keyBy(array, v => _.get(v, viewOptions.field))

    let visibleValues = catalog.sectionValues
      .get(sectionConfig.id)
      ?.filter(({ key }) => {

        const lookup = `${path}.${viewOptions.field}.${key}`

        return catalog.cardView.all || catalog.cardView[lookup]
      })

    if (!visibleValues.length || visibleValues.length > visible) {
      visibleValues = [...(visibleValues.length > visible ? visibleValues : catalog.sectionValuesFor(sectionConfig.id))].splice(0, (visible * (field.def?.type !== "String" ? 3 :  1)))
    }

    const contents = visibleValues.length ? visibleValues?.map(({ key }) => {
      const value = _.get(dict[key], field.field.substring(path.length ? path.length + 1 : 0)),
        id = catalog.idFor(data)

      switch (field.def?.type) {
        case 'Boolean': {
          return <CheckboxPDF key={`${key}_${id}`} label={key} checked={Boolean(value)} />
        }
        case 'Int': {
          return <SectionField key={`${key}_${id}`} columns={columns}>
            <SectionFieldLabel><SectionText>{key}</SectionText></SectionFieldLabel>
            <SectionFieldValue><SectionText>{value ?? strings.emptyLabel}</SectionText></SectionFieldValue>
          </SectionField>
        }
        case 'DateTime': {
          return <SectionField key={`${key}_${id}`} columns={columns}>
            <SectionFieldLabel><SectionText>{key}</SectionText></SectionFieldLabel>
            <SectionFieldValue><SectionText>{value ? new Date(value).toLocaleDateString("en-US", { year: '2-digit', month: '2-digit', day: '2-digit' }) : strings.emptyLabel}</SectionText></SectionFieldValue>
          </SectionField>
        }
        default: {
          return <VlpProductCardLineItem
          columns={columns}
          key={`${key}_${id}`}
          left={`${key}: `}
          showLabel
          right={(value || strings.emptyLabel )}/>
        }
      }
    }) : <Text>No Selected {pluralize(sectionConfig.label)}</Text>

  return <Fragment>
    {contents && <ViewRoot key={field.label}>
      <CheckboxTextView>
        {!showCardLabels ? null : <Text>{field.label}</Text>}
      </CheckboxTextView>
      {contents}
    </ViewRoot>}
  </Fragment>
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/RegionSelection.tsx